import {Component, ViewChild} from '@angular/core';
import {Http} from '@angular/http';
import {ToasterService} from 'angular2-toaster/angular2-toaster';
import { Router } from '@angular/router';

import {DataTable} from './../../services/DataTable';
import {UsersService} from "../../models/users/users.service";
import {UsersModel} from "../../models/users/users.model";

class UserPassEditor {
    private _id: number;
    public pass: string;
    private _lastId: number;
    private _lastState: number;

    private _state_o;

    constructor () {
        this._id = 0;
        this.pass = '';
        this._lastId = 0;
        this._state_o = {};
        this._lastState = -1;
    }

    get id() {
        return this._id;
    }

    set id(value: number) {
        this._state_o = {};
        this._lastState = -1;
        this._lastId = this._id;
        this._id = value;
        this.pass = '';
    }

    setIdIfNotSame(id: number) {
        if (id != this.id) this.id = id;
    }

    get canSave() {
        return this.pass.length >= 3;
    }

    isEditing(id) {
        return id == this._id;
    }

    cancel() {
        this._id = 0;
    }

    set stateBool(value: boolean) {
        this._lastId = this._id;
        if (value) this._id = 0;
        this._lastState = value ? 0 : 1;
        this._state_o = {};
        setTimeout(
            (() => {
                let o1 = this._state_o;
                return () => {
                    if (this._state_o === o1) this._lastState = -1;
                };
            }) (),
            2400
        );
    }

    state(id): number {
        if (id != this._lastId) return -1;
        return this._lastState;
    }

    isStateOk(id) {
        let state = this.state(id);
        return state > -0.1 && state < 0.1;
    }

    isStateErr(id) {
        let state = this.state(id);
        return state > 0.9;
    }

    get stateId() {
        return this._lastId;
    }
}

@Component({
    selector: 'users',
    templateUrl: 'users-list.template.html',
    styleUrls: ['users-list.css']
})

export class UsersListComponent {
    @ViewChild('userModal') public userModal;
    @ViewChild('userRemoveConfirm') public userRemoveConfirm;

    public dataTable: DataTable;
    public modelToEdit = new UsersModel();

    private passEditor: UserPassEditor;

    constructor(
        private http: Http,
        private router: Router,
        private toasterService: ToasterService,
        public usersService: UsersService
    ) {
        this.dataTable = new DataTable(this.usersService);
        this.dataTable.fetch();
        this.passEditor = new UserPassEditor();
    }

    public removeUser(model:UsersModel) {
        this.userRemoveConfirm.show(model);
    }

    public openOne(model:UsersModel) {
        this.router.navigate(['/users/' + model.id])
    }

    public openUserCreate() {
        this.router.navigate(['/users/create']);
    }

    public onRemove(model:UsersModel) {
        this.usersService.remove(model.id)
            .toPromise()
            .then(() => {
                this.dataTable.refresh();
                this.userRemoveConfirm.hide();

                this.toasterService.pop('success', 'Success', 'User deleted');
            })
    }

    public onSave(model: UsersModel) {
        this.usersService.add(model)
            .subscribe(
                () => {
                    this.dataTable.refresh();
                    this.userModal.userForm.enable();
                    this.userModal.userForm.reset();
                    this.userModal.hide();
                    this.toasterService.pop('success', 'Success', 'New user created');
                },
                (error) => {
                    this.userModal.userForm.enable();
                    let errorData = JSON.parse(error._body);
                    this.userModal.showError(errorData.errors);
                });
    }

    public savePass() {
        this.usersService.setPass(this.passEditor.id, this.passEditor.pass)
            .subscribe(
                (res) => {
                    this.toasterService.pop('success', 'Success', 'Password modified');
                    this.passEditor.stateBool = true;
                },
                (error) => {
                    let errorData = JSON.parse(error._body);
                    this.toasterService.pop('error', 'Error', errorData.message);
                    this.passEditor.stateBool = false;
                }
            );
    }
}


// WEBPACK FOOTER //
// ./src/app/views/users/users-list.component.ts